import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { ConfiguracoesProjeto, GenericHttpService, ParametrosService } from '..';
import { EnderecoModel } from './endereco.model';
import { FiltroEnderecoPorLogradouroModel } from '../model/filtro-endereco-logradouro';

@Injectable()
export class EnderecoService {

    public enderecoCEP: Subject<EnderecoModel>;
    public enderecoModel: EnderecoModel;

    public _urlBase: string;
    public configuracao: ConfiguracoesProjeto;

    constructor(private readonly genericHttpService: GenericHttpService<EnderecoModel>,
                private readonly parametrosService: ParametrosService) { }

    get urlBase() {
        this.configuracao = this.parametrosService.getConfiguracao();
        this._urlBase = this.configuracao.uri + 'endereco';

        return this._urlBase;
    }

    getEnderecoPeloCep(cep: string) {
        const regEx = /\^|~|\?|,|\*|\.|\-/g;
        const strCEP = cep.replace(regEx, '');
        return this.genericHttpService.getById(this.urlBase + `/cep/${strCEP.toString()}`);
    }

    getEnderecoPeloLogradouro(filtro: FiltroEnderecoPorLogradouroModel) {
        return this.genericHttpService.getAllParam(this.urlBase + `/logradouro/`, filtro);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/endereco/endereco.service.ts